<template>
  <Modal 
    :id="'cmp-distiribution-change-pick-status'"
    @cancelled="onCancel"
  >
    
    <template slot="header">{{$t('status')}}</template>

    <template slot="body">
      <div class="r-container">
        <div  v-for="item in pickStatusList" :key="item.value" class="ut-flex r-flex-container">
            <div>
              <input
                type="radio"
                :checked="isSelected(item)"
                @change="(e) => onSelect(item)"
                value="tax_group"
                name="tax_group"
              />
            </div>
            <div class="r-label">
              {{item['label']}}
            </div>
        </div>
      </div>
    </template>

    <template slot="options">
        <button class="dt-button s6" @click="onCancel">{{$t('cancel')}}</button>
    </template>

  </Modal>
</template>

<script>
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { OrderService } from '../../services/order.service';
import Modal from '@/dt-plugins/modal/modal';

export default {
  components: {
    NTable,
    Modal
  },
  props: {


  },

  mounted:async function() {
    const pickStatusData=await OrderService.orderlineStatusList() ;
    this.pickStatusList=pickStatusData.data.status_list
    console.log("::::DATA::::",this.pickStatusList)

  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        fullHeight: true,
        showHeader: false,
      }),
      pickStatusList:[],
      selectedStatus:{},
    };
  },
  computed: {


  },
  methods: {
    onCancel: function() {
  
      this.$emit("cancelled", true);
    },
    onSelect:function(item){
      console.log(":::::",item)
      this.selectedStatus=item
      this.$emit("changePickStatus",{ status:this.selectedStatus?.value })
    },
    
    isSelected: function (item) {
      return (
        (this.selectedStatus &&
          item?.value ==
            this.selectedStatus?.value) ||
        item?.label ==
          this.selectedStatus?.label
      );
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-distiribution-change-pick-status {
  .r-container{
    border: 1px solid var(--sprt-5);
    background: #f8f8f8;
    border-radius:3px ;
    .r-flex-container{
      padding: 5px;
      border-bottom: 1px solid var(--sprt-7);
      .r-label{
        margin-left: 5px;
        margin-top: -5px;
      }
    }
    
  }
  
}
</style>
